import {
  getPrintVolumeTotal,
  getHomeCounts
} from '@/api/dashboard'

export default {
  state: {
    // 印量总数数据
    printVolumeData: {
      totalPages: 0,
      todayPages: 0,
      queryTime: '0'
    },
    // 首页统计数据
    homeCountsData: {
      todayOrderCount: 0,
      machineCount: 0,
      userCount: 0
    },
    // 加载状态
    loading: false
  },
  getters: {
    // 获取印量总数
    totalPages: state => state.printVolumeData.totalPages,
    // 获取今日印量
    todayPages: state => state.printVolumeData.todayPages,
    // 获取查询时间
    queryTime: state => state.printVolumeData.queryTime,
    // 获取当日订单量
    todayOrderCount: state => state.homeCountsData.todayOrderCount,
    // 获取设备接入数
    machineCount: state => state.homeCountsData.machineCount,
    // 获取用户数
    userCount: state => state.homeCountsData.userCount,
    // 获取加载状态
    dashboardLoading: state => state.loading
  },
  actions: {
    // 获取印量总数数据
    async getPrintVolumeTotal ({ commit }) {
      commit('SET_LOADING', true)
      try {
        const res = await getPrintVolumeTotal()
        if (res.data.status) {
          commit('SET_PRINT_VOLUME_DATA', res.data.data)
          return res.data.data
        } else {
          throw new Error(res.data.msg || '获取印量数据失败')
        }
      } catch (error) {
        console.error('获取印量总数失败:', error)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    // 获取首页统计数据
    async getHomeCounts ({ commit }) {
      commit('SET_LOADING', true)
      try {
        const res = await getHomeCounts()
        if (res.data.status) {
          commit('SET_HOME_COUNTS_DATA', res.data.data)
          return res.data.data
        } else {
          throw new Error(res.data.msg || '获取首页统计数据失败')
        }
      } catch (error) {
        console.error('获取首页统计数据失败:', error)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  mutations: {
    // 设置印量数据
    SET_PRINT_VOLUME_DATA (state, data) {
      state.printVolumeData = {
        totalPages: data.totalPages || 0,
        todayPages: data.todayPages || 0,
        queryTime: data.queryTime || '0'
      }
    },
    // 设置首页统计数据
    SET_HOME_COUNTS_DATA (state, data) {
      state.homeCountsData = {
        todayOrderCount: data.todayOrderCount || 0,
        machineCount: data.machineCount || 0,
        userCount: data.userCount || 0
      }
    },
    // 设置加载状态
    SET_LOADING (state, loading) {
      state.loading = loading
    }
  }
}
